import { FormLabel, FormControl, FormGroup, Col } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
//

const LabelErrors = ({
  name = '',
  labelClass ='',
  errorMessage = '',
}) => (
  <FormLabel
    className={`text-danger  ${labelClass}`}
    for={name}
    style={{ fontWeight: '400' }}
  >
    {errorMessage}
  </FormLabel>
)

const ReactstrapInput = ({
  control = {},
  name = '',
  label = undefined,
  type = 'text',
  as = undefined,
  min = 0,
  handleCodeScanned = () => {},
  autoFocus= false,
  required = false,
  defaultValue = undefined,
  rows = undefined,
  disabled = false,
  // style = {},
  placeholder = undefined,
  errorMessage = undefined,
  noGrid = false,
  showError = true,
  colClass = '',
  formGroupClass = 'mb-0',
  xxl = '6',
  xl = '6',
  lg = '6',
  md = '6',
  sm = '12',
  xs = '12',
  ...rest
}) => {
  const renderInput = () => (
    <>
      {label && (
        <FormLabel for={name}>
          {label} {required && <span className='text-danger'>*</span>}
        </FormLabel>
      )}
      <Controller
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => (
          <>
            <div className='d-flex align-items-center w-100'>
              <FormControl
                {...field}
                type={type}
                min={min}
                as={as}
                autoFocus={autoFocus}
                disabled={disabled}
                placeholder={placeholder}
                rows={rows}
                isInvalid={errorMessage}
                className={`${!field?.value ? '' : 'bz-pr-28'} ${
                  errorMessage ? '' : ''
                }`}
                ref={undefined}
                innerRef={field?.ref}
                onKeyDown={(e) => {
                  if (type === 'number') {
                    return (
                      ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
                    )
                  }
                  if (e.key === "Enter") {  // Scanner usually sends 'Enter' after scanning
                    // e.preventDefault();
                    handleCodeScanned(e);
                    const scannedValue = e.target.value.trim();
                    // console.log("Barcode Scanned:", scannedValue);
                  }
                  return e
                }}
                onPaste={(e) => {
                  if (type === 'number') {
                    const paste = (
                      e.clipboardData || window.clipboardData
                    ).getData('text')
                    if (isNaN(paste)) {
                      return e.preventDefault()
                    }
                  }
                  console.log(e)
                  return e
                }}
                {...rest}
              />
              {/* {field?.value && !disabled ? (
                <div className='position-relative'>
                  <button
                    type='button'
                    onClick={() => {
                      // eslint-disable-next-line no-underscore-dangle
                      // control._fields[name]?._f.ref.focus() // This doesn't work, gives error !!!!!!!!
                      field.onChange('')
                    }}
                    style={{ left: -27, top: -14 }}
                    className='btn close position-absolute'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </div>
              ) : null} */}
            </div>
          </>
        )}
        control={control}
      />
      {showError && <LabelErrors name={name} errorMessage={errorMessage} />}
    </>
  )

  return (
    <>
      {noGrid ? (
        <FormGroup className={formGroupClass}>{renderInput()}</FormGroup>
      ) : (
        <>
          <Col
            className={colClass}
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            xxl={xxl}
          >
            <FormGroup className={formGroupClass}>{renderInput()}</FormGroup>
          </Col>
        </>
      )}
    </>
  )
}

export default ReactstrapInput
